export default __webpack_public_path__ + "de31c56e91582981f4765468c7c8d157.png";